var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg20ArrowLeft(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "20-arrow-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5689 7.28539C11.9911 7.68284 12.0113 8.34735 11.6138 8.76964L7.67937 12.95H22.7492C23.3291 12.95 23.7992 13.4201 23.7992 14C23.7992 14.5799 23.3291 15.05 22.7492 15.05H7.67937L11.6138 19.2304C12.0113 19.6527 11.9911 20.3172 11.5689 20.7146C11.1466 21.1121 10.482 21.0919 10.0846 20.6696L4.48461 14.7196C4.10409 14.3153 4.10409 13.6847 4.48461 13.2804L10.0846 7.33037C10.482 6.90809 11.1466 6.88795 11.5689 7.28539Z",
    fill: "#182BCF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg20ArrowLeft);
export default __webpack_public_path__ + "static/media/20-arrow-left.311e15642236ce1b04fbffdfe9674a8d.svg";
export { ForwardRef as ReactComponent };